import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import { Form, Input, Button, message } from 'antd';
import isBrowser from '../../shared/helpers';

import styles from './index.module.scss';

function LandingForm() {
  let userInfo = null;
  if (isBrowser() && window.localStorage.getItem('userInfo')) {
    userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
  }

  const [formData, setFormData] = useState({
    fullName: userInfo ? userInfo.fullName : '',
    company: userInfo ? userInfo.company : '',
    email: userInfo ? userInfo.email : '',
  });
  const [redirectReady, setRedirectReady] = useState(false);

  useEffect(() => {
    setRedirectReady(true);
  }, []);

  function onSubmit() {
    if (isBrowser()) {
      window.localStorage.setItem('userInfo', JSON.stringify(formData));
    }
    navigate('/questions');
  }

  return (
    redirectReady && (
      <Form className={styles.form} onFinish={onSubmit}>
        <Form.Item
          name="fullName"
          rules={[
            {
              required: true,
              message: 'Veuillez saisir votre nom ainsi que votre prénom',
            },
            {
              pattern: /^([a-zA-Z]{2,}\s[a-zA-z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)/,
              message: 'Veuillez saisir un nom et prénom valides',
            },
          ]}
        >
          <Input
            className={styles.inputs}
            placeholder="Nom et prénom"
            defaultValue={formData.fullName}
            onChange={(e) =>
              setFormData({ ...formData, fullName: e.target.value })
            }
          />
        </Form.Item>
        <Form.Item
          name="company"
          rules={[
            {
              required: true,
              message: 'Veuillez saisir le nom de votre société',
            },
            {
              pattern: /^.{2,}$/,
              message:
                "Le nom de votre société doit être composé d'au moins 2 lettres",
            },
          ]}
        >
          <Input
            className={styles.inputs}
            placeholder="Société"
            defaultValue={formData.company}
            onChange={(e) =>
              setFormData({ ...formData, company: e.target.value })
            }
          />
        </Form.Item>
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Veuillez saisir votre adresse e-mail' },
            {
              type: 'email',
              message: 'Veuillez saisir une adresse e-mail valide',
            },
          ]}
        >
          <Input
            className={styles.inputs}
            type="email"
            placeholder="Adresse e-mail"
            defaultValue={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
        </Form.Item>
        <Button className={styles.button} type="primary" htmlType="submit">
          Entrer
        </Button>
      </Form>
    )
  );
}

export default LandingForm;
